import Regex from '../regex';

/**
 * Validates a name based on length constraints.
 *
 * @param {string} value - The name to be validated.
 * @returns {string|undefined} - Returns an error message if the name is invalid, otherwise undefined.
 */
export const nameValidation = value => {
  if (value && value.length < 4) return 'Name must be at least 4 characters';
  if (value && value.length > 100)
    return 'Name must be less than 100 characters';
  if (value && Regex.specialCharacterWithNumbers.test(value))
    return 'Name can not have special characters and numbers';
  return;
};

/**
 * Validates a phone number based on various formats.
 *
 * Valid formats include:
 * - 2124567890
 * - 212-456-7890
 * - (212)456-7890
 * - (212)-456-7890
 * - 212.456.7890
 * - 212 456 7890
 * - +12124567890
 * - +1 212-456-7890
 * - +1 212.456.7890
 * - +212-456-7890
 * - 1-212-456-7890
 *
 * @param {string} value - The phone number to be validated.
 * @param {string} type - The type (phone or fax) being validated.
 * @returns {string|undefined} - Returns an error message if the phone number is invalid, otherwise undefined.
 */
export const phoneAndFaxValidation = (value, type) => {
  const pattern = Regex.phoneAndFax;
  if (value && !pattern.test(value))
    return `Please enter a valid ${type} number`;
  return;
};

export const shortNameValidation = value => {
  if (value && value.length !== 4)
    return 'Short Name must be of 4 characters only';
  if (value && Regex.specialCharacterWithNumbers.test(value))
    return 'Short Name can not have special characters or numbers';
  return;
};

export const facilityShortNameValidation = value => {
  if (value && Regex.specialCharacters.test(value))
    return 'Short Name can not have special characters';
  return;
};

export const facilityNameValidation = value => {
  if (value && value.length < 4) return 'Name must be at least 4 characters';
  if (value && value.length > 100)
    return 'Name must be less than 100 characters';
  if (value && Regex.containNumber.test(value))
    return 'Name can not have numbers';
  return;
};

export const validateDate = (date, lowerLimit) => {
  const getUtcMidnightTimestamp = dateObj =>
    Date.UTC(
      dateObj.getUTCFullYear(),
      dateObj.getUTCMonth(),
      dateObj.getUTCDate(),
    );

  // Parse lower limit stored in UTC string to Date
  const lowerLimitDate = new Date(lowerLimit);

  const selectedUtcMidnight = getUtcMidnightTimestamp(date);
  const lowerUtcMidnight = getUtcMidnightTimestamp(lowerLimitDate);

  // Get local now (user system time)
  const nowLocal = new Date();

  // Calculate 'today' in user local timezone as UTC midnight timestamp (treat local midnight as UTC midnight)
  // This means: treat local date's year, month, day as if it was UTC date.
  const todayUtcMidnight = Date.UTC(
    nowLocal.getFullYear(),
    nowLocal.getMonth(),
    nowLocal.getDate(),
  );

  if (selectedUtcMidnight <= lowerUtcMidnight) {
    return 'You cannot set a date earlier than or equal to the discharge date';
  }

  if (selectedUtcMidnight > todayUtcMidnight) {
    return 'You cannot set a future date';
  }

  return undefined;
};

export const validateCharges = value => {
  const regex = /^\d+(\.\d+)?$/;
  return regex.test(value) ? '' : 'Charge Per API should be a number';
};

export const IdentifierValidation = value => {
  if (value && Regex.specialCharacters.test(value))
    return 'Identifiers can not have special characters';
  return;
};
